import { InputSwitch } from 'primereact/inputswitch'

import { cap } from '../../../State'
import { translations } from '../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

/**
 * Componente per la creazione di un pannello con switch e testo associato.
 *
 * @param {boolean} checked - Indica se lo switch è attivo.
 * @param {function} onChange - Funzione chiamata quando lo stato dello switch cambia.
 * @param {string} headerValue - Testo visualizzato come etichetta dello switch.
 * @param {string} description - Descrizione testuale aggiuntiva sotto l'etichetta.
 */
const CheckboxPanel = ({ checked, onChange, headerValue, description }) => (
  <div className="nfield community-toggle-panel" style={{ gridColumn: 'span 3' }}>
    <label>{headerValue}</label>
    <div className="community-toggle-row">
      <InputSwitch checked={checked} onChange={(e) => onChange(e.value)} />
      <span>{checked ? t.abilitato : t.admDisabilitato}</span>
    </div>
    {description && <div className="nfield__hint">{description}</div>}
  </div>
)

export default CheckboxPanel
